import mitt from "mitt";

type Events = {
	sendMsg : string;
	sendNum : number;
};

const bus = mitt<Events>();
export default bus;